import { Box, Typography, TextField } from "@mui/material";
import React from "react";

export const Step2 = (props) => {
  const { register, errors } = props;
  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6">Ubicación del riesgo</Typography>
      <TextField
        {...register("direccionRiesgo", {
          required: "La dirección es obligatoria",
        })}
        label="Dirección completa del riesgo"
        fullWidth
        required
        multiline
        sx={{ mb: 2, mt: 2 }}
        error={!!errors.direccionRiesgo}
        helperText={errors.direccionRiesgo?.message}
      />
      <TextField
        {...register("numeroCatastral", {
          required: "El número catastral es obligatorio",
        })}
        label="Número de identificación catastral"
        fullWidth
        required
        sx={{ mb: 2 }}
        error={!!errors.numeroCatastral}
        helperText={errors.numeroCatastral?.message}
      />
    </Box>
  );
};

export default Step2;
